import {
  createPlateUI,
  ELEMENT_IMAGE,
  ELEMENT_LINK,
  ELEMENT_PARAGRAPH,
  ELEMENT_TABLE,
  ELEMENT_TD,
  ELEMENT_TH,
  ELEMENT_UL,
  ELEMENT_OL,
  ELEMENT_LIC,
} from '@udecode/plate';

import { AgentMentionSearch, MARK_AGENT_MENTION_SEARCH } from 'components/text_editor_new/plugins/agent_mention';
import { InlineImage } from 'components/text_editor_new/plugins/inline_image/inline_image';
import { StyledLinkInline } from 'components/composer/inline_links/inline_link';
import { StyledP } from 'components/text_editor_new/plugins/paragraph_styles';
import {
  StyledAITextCompletionSelection,
  MARK_AI_TEXT_COMPLETION_SELECTION,
} from 'components/text_editor_new/plugins/ai/ai_text_completion';
import {
  StyledAITextCompletionHighlight,
  MARK_AI_TEXT_COMPLETION_HIGHLIGHT,
} from 'components/text_editor_new/plugins/ai/ai_text_completion/ai_text_completion_highlight';
import { MARK_LINK_SELECTION } from 'components/text_editor_new/plugins/inline_links/create_link_selection_plugin';
import { MARK_URL_HIGHLIGHT } from 'components/text_editor_new/plugins/inline_links/create_url_highlight_plugin';
import { InlineLinkSelection } from 'components/text_editor_new/plugins/inline_links/inline_link_selection';
import { StyledUrlHighlight } from 'components/text_editor_new/plugins/inline_links/url_highlight_mark';
import { StyledLic, StyledOl, StyledUl } from 'components/text_editor_new/plugins/list_components';
import { TableCellElement, TableElement } from 'components/text_editor_new/plugins/table/table_components';

// Overriding built-in components from plugin factories does not work.  So we
// override them here. See https://plate.udecode.io/docs/styling#plate-ui
const components = createPlateUI({
  [ELEMENT_IMAGE]: InlineImage,
  [ELEMENT_LINK]: StyledLinkInline,
  [ELEMENT_PARAGRAPH]: StyledP,
  [ELEMENT_TABLE]: TableElement,
  [ELEMENT_TD]: TableCellElement,
  [ELEMENT_TH]: TableCellElement,
  [ELEMENT_UL]: StyledUl,
  [ELEMENT_OL]: StyledOl,
  [ELEMENT_LIC]: StyledLic,
  [MARK_AI_TEXT_COMPLETION_HIGHLIGHT]: StyledAITextCompletionHighlight,
  [MARK_AI_TEXT_COMPLETION_SELECTION]: StyledAITextCompletionSelection,
  [MARK_AGENT_MENTION_SEARCH]: AgentMentionSearch,
  [MARK_LINK_SELECTION]: InlineLinkSelection,
  [MARK_URL_HIGHLIGHT]: StyledUrlHighlight,
});

export default components;
